import { Typography } from '@mui/material';
import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiService } from '../../services/ApiServiceProvider';
import SnackbarAlert, { Severity } from '../alert/SnackbarAlert';
import { useLocation } from 'react-router-dom';

export const ProlificStudyIdView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const apiService = useApiService();
  const [retrieving, setRetrieving] = useState(false);
  const [prolificStudyId, setProlificStudyId] = React.useState<string | null>(null);
  const [displayError, setDisplayError] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [snackbarContent, setSnackbarContent] = useState<ReactNode>();
  const [snackbarSeverity, setSnackbarSeverity] = useState<Severity>('info');
  const participantId = location.state?.participantId || null;

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const showSnackbar = (title: string, content: ReactNode, severity: Severity) => {
    setSnackbarTitle(title);
    setSnackbarContent(content);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => { 
    if (!participantId) {
        setDisplayError(true);
        showSnackbar('Error', 'Missing participant ID.', 'error');
        return;
    }

    setRetrieving(true);

    apiService.getProlificStudyId(participantId).then((prolificStudyId: any) => {
      setProlificStudyId(prolificStudyId);
      setRetrieving(false);

      if(!prolificStudyId) {
        setDisplayError(true);
        showSnackbar('Not found', 'Unable to retrieve your Prolific study ID.', 'error');
      }
    })
    .catch((error: any) => {
      console.error('Error retrieving Prolific study ID:', error)
      setRetrieving(false);
      setDisplayError(true);
      showSnackbar('Error', error?.message || 'An error occurred while retrieving Prolific study ID.', 'error');
    });
  }, [apiService, participantId]);

  return (
    <>
      <Typography variant="h4" component='h1' id="main-heading" tabIndex={-1}>{t('All tasks completed')}</Typography>
      <div style={{ textAlign: 'center' }}>
        <img src="/assets/images/b2ai-thank-you.jpg" alt="Thank you" style={{maxHeight: '30rem'}} />
      </div>
      {prolificStudyId ? (
        <Typography variant="h5" component="div" style={{ marginTop: '2rem' }}>
          {t('Your Prolific study ID is')}: {prolificStudyId}
        </Typography>
      ) : (
        retrieving ? 
          <Typography variant="h5" component="div" style={{ marginTop: '2rem' }}>
            {t('Retrieving Prolific study ID...')}
          </Typography>
         : null
      )}

      {displayError && (
        <SnackbarAlert
          open={snackbarOpen}
          title={snackbarTitle}
          severity={snackbarSeverity}
          content={snackbarContent}
          vertical='top'
          onClose={handleSnackbarClose}
        />
      )}
    </>
  );
}
